import { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import html2pdf from "html2pdf.js";
import React from "react";
import _ from "lodash/fp";
import dayjs from "dayjs";
import { Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { format } from "date-fns";
import commonLabels from "../../../common/labels/common_en.json";
import TablePagination from "../../../common/components/TablePagination";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getSubjectlistByExamId,
  getExaminersAndModeratorReportData,
  getAllApprovalMarksCriteria,
  getCandidateCountByExamIdSubjectId,
  saveChiefModeratorMarksCriteria,
  getSupervisorlistByExamIdSubjectId,
  getModeratorCandidateCountByExamIdSubjectId,
  saveModeratorMarksCriteria,
  getModeratorCandidateListByExamIdSubjectId,
  getAllApprovalModeratorCriteria,
  getModeratorCandidateCountByPercentage,
  getModeratorCriteriaStatus,
  getModeratorModeration,
} from "../../actions/postExaminationProcessObjectiveActions";

import ApprovalModeratorCriteriaEntity from "../examReport/ApprovalModeratorCriteriaEntity";
import {
  getYearList,
  getAdvertisementlistByYear,
} from "../../../common/actions/commonActions";
import { sl } from "date-fns/locale";
import { toastr } from "react-redux-toastr";

let headerField = [
  {
    id: "1",
    steps: "Step 1",
    name: "Criteria",
  },
  {
    id: "2",
    steps: "Step 2",
    name: "Approvals Criteria",
  },
  {
    id: "3",
    steps: "Step 3",
    name: "Get Candidates List",
  },
  {
    id: "4",
    steps: "Step 4",
    name: "Moderation Not Done",
  },
];

const ModeratorCriteria = () => {
  const pdfRef = useRef(null);

  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  let {
    examList,
    advertisementList,
    subjectList,
    supervisorListById,
    moderatorMarkCount,
    moderatorCandidateList,
    moderatorCriteriaApprovalList,
    moderatorCriteriaApprovalPageNoCounter,
    percentageCount,
    moderatorCriteriaStatus,
    getModerationData,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let tableCounterMarkCriteria = moderatorCriteriaApprovalPageNoCounter + 1;
  let rowPerPage = 10;

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedSupervisor, setSelectedSupervisor] = useState(1);
  const [supervisor, setSupervisor] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [moderatorCount, setModeratorCount] = useState([]);

  const [percentage, setPercentage] = useState("");
  const [percentageValue, setPercentageValue] = useState([]);

  const [totalCount, setTotalCount] = useState(0);
  const [remainingCount, setRemainingCount] = useState(0);

  const session = JSON.parse(sessionStorage.getItem("session"));
  const [rows, setRows] = useState([{}]);

  const [stepName, setName] = useState("1");

  let [
    selectedModeratorCriteriaApprovalEntity,
    setSelectedModeratorCriteriaApprovalEntity,
  ] = useState("");
  let [
    moderatorCriteriaApprovalEntityModal,
    setModeratorCriteriaApprovalEntityModal,
  ] = useState(false);
  let [listMarkCriteriaCurrentPage, setListMarkCriteriaCurrentPage] =
    useState(0);
  const date = new Date();

  const [uniqueValues, setUniqueValues] = useState([]);

  // useEffect(() => {
  //   if (moderatorCount) {
  //     const values = [...new Set((moderatorCount?.barcodeNumberList).concat(percentageValue?.barcodeNumberList || []))];
  //     setUniqueValues(values);
  //   }
  // }, [moderatorCount, percentageValue]);

  let totalSelectedCandidate = 0;
  for (let i = 0; i < moderatorCount.length; i++) {
    if (moderatorCount[i]) {
      totalSelectedCandidate += moderatorCount[i].totalSelectedCount;
    }
  }
  let firstTotalCandidateCount = 0;
  if (moderatorCount.length > 0) {
    firstTotalCandidateCount = moderatorCount[0].totalCandidateCount;
  }

  let remainingCandidateCount =
    firstTotalCandidateCount - totalSelectedCandidate;

  let combinedBarcodeNumbers;

  useEffect(() => {
    if (combinedBarcodeNumbers || percentageValue) {
      // const moderatorList = moderatorCount.barcodeNumberList || [];
      const percentageList = percentageValue.barcodeNumberList || [];

      const values = [
        ...new Set([...combinedBarcodeNumbers, ...percentageList]),
      ];

      setUniqueValues(values);
    }
  }, [combinedBarcodeNumbers, moderatorCount, percentageValue]);

  // useEffect(() => {

  // }, [moderatorCount]);

  const dispatch = useDispatch();

  const formData = rows.map((row, index) => ({
    minMarks: row.minMarks,
    maxMarks: row.maxMarks,
    totalSelectedCandidateMarks:
      moderatorCount[index] && moderatorCount[index].totalSelectedCount,
    percentage: percentage,
    totalSelectedCandidatePercentage: percentageValue.totalSelectedCount,
  }));

  const marksData = rows.map((row) => ({
    minMarks: row.minMarks,
    maxMarks: row.maxMarks,
  }));

  // let combinedBarcodeNumbers;

  // if (Array.isArray(moderatorCount)) {
  //   combinedBarcodeNumbers = moderatorCount?.barcodeNumberList;
  // }

  if (Array.isArray(moderatorCount)) {
    combinedBarcodeNumbers = moderatorCount
      .map((item) => item.barcodeNumberList)
      .flat();
  }

  const formPercentageData = {
    percentage: percentage,
    barcodeNumbers: combinedBarcodeNumbers,
  };

  const addRow = () => {
    setRows([...rows, {}]);
  };

  // const removeRow = (index) => {
  //   const newRows = [...rows];
  //   newRows.splice(index, 1);
  //   setRows(newRows);
  // };

  function removeRow(index) {
    let newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);

    const newModeratorCount = [...moderatorCount];
    newModeratorCount.splice(index, 1);
    setModeratorCount(newModeratorCount);

    setPercentageValue([]);
    setPercentage("");
  }

  useEffect(() => {
    dispatch(getYearList());
    if (stepName === "2") {
      dispatch(getAllApprovalModeratorCriteria(0, rowPerPage));
    }
    // setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (stepName === "2") {
      dispatch(
        getAllApprovalModeratorCriteria(listMarkCriteriaCurrentPage, rowPerPage)
      );
    }
  }, [stepName, listMarkCriteriaCurrentPage, rowPerPage, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    onCancelButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (moderatorMarkCount) {
      setModeratorCount(moderatorMarkCount);
    }
  }, [moderatorMarkCount]);

  useEffect(() => {
    if (percentageCount) {
      setPercentageValue(percentageCount);
    }
  }, [percentageCount]);

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    examList.length = 0;
    subjectList.length = 0;
    setSelectedExam("");
    setSelectedSubject("");
    setSaveButtonFlag(true);
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    subjectList.length = 0;
    setSelectedExam(selectedValue);
    setSelectedSubject("");
    setSaveButtonFlag(true);
    selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onSubjectChange = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    dispatch(getModeratorCriteriaStatus(selectedExam, selectedValue));
    // selectedValue && dispatch(getSupervisorlistByExamIdSubjectId(selectedExam, selectedValue));
    //onSubmit(selectedValue);
    setReloadItem(!reloadItem);
    supervisorListById.length = 0;
  };

  const onChangeSubject = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    // selectedValue && dispatch(getSupervisorlistByExamIdSubjectId(selectedExam, selectedValue));
    //onSubmit(selectedValue);
    selectedValue !== "" &&
      dispatch(
        getModeratorCandidateListByExamIdSubjectId(
          selectedExam,
          selectedValue,
          downloadCSV,
          onCancelButton
        )
      );
    setReloadItem(!reloadItem);
  };

  const onChangeSub = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    selectedValue &&
      dispatch(getModeratorModeration(selectedExam, selectedValue));
    setSaveButtonFlag(false);
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5>' +
      commonLabels.MPSC +
      "</h5><h5>" +
      getModerationData.examName +
      "</h5><h5>" +
      label.MODERATIONNECESSARYBUTNOTDONE +
      "</h5><h5>" +
      getModerationData.subjectName +
      "</h5></div>";
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "ModeratorModeration.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = getModerationData.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`ModeratorModeration_${selectedExam}.pdf`);
      });
  };

  // const onChangeSupervisor = (ele) => {
  //   let selectedValue = ele;
  //   setSupervisor(selectedValue);
  //   setSaveButtonFlag(false);
  //   setReloadItem(!reloadItem);
  // };

  // const onSubmit = () => {
  //   dispatch(
  //     saveModeratorMarksCriteria(selectedExam, selectedSubject, formData, supervisor));
  //   setReloadItem(!reloadItem);
  // if(allYearList){
  //   allYearList.length=0
  // }
  // if(examList){
  //   examList.length=0;
  // }
  // if(subjectList){
  //   subjectList.length=0;
  // }
  // if(supervisorListById){
  //   supervisorListById.length=0
  // }
  // };

  // const onMinMarksChange = (ele) => {
  //   let selectedValue = ele;
  //   setMinMarks(selectedValue);
  // };

  // const onMaxMarksChange = (ele) => {
  //   let selectedValue = ele;
  //   setMaxMarks(selectedValue);
  // };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setSupervisor("");
    setPercentage("");
    setSelectedYear("");
    setModeratorCount([]);
    setPercentageValue([]);
    setUniqueValues([]);
    setRows([{}]);
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);

    allYearList.length = 0;
    examList.length = 0;
    subjectList.length = 0;
    supervisorListById.length = 0;
    totalSelectedCandidate = 0;
    firstTotalCandidateCount = 0;
    remainingCandidateCount = 0;
    combinedBarcodeNumbers = [];
  };

  useEffect(() => {
    onCancelButton();
  }, [stepName]);

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton();
    } else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      if (subjectList) {
        subjectList.length = 0;
      }
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
    }
  };

  // const onChangeSupervisorId = (ele) => {
  //   let selectedValue = ele;
  //   setSupervisor(selectedValue);
  //   setSaveButtonFlag(false);
  //   selectedValue !== "" && dispatch(getModeratorCandidateListByExamIdSubjectId(selectedExam, selectedSubject, selectedValue, downloadCSV));
  //   setReloadItem(!reloadItem);
  // };

  const onSubmit = () => {
    dispatch(
      saveModeratorMarksCriteria(
        selectedExam,
        selectedSubject,
        formData,
        moderatorCriteriaStatus
      )
    );
    setReloadItem(!reloadItem);
    onCancelButton();
  };

  const handleMarksCriteriaApproval = (ele) => {
    setSelectedModeratorCriteriaApprovalEntity(ele);
    setModeratorCriteriaApprovalEntityModal(true);
  };

  const onCalculate = (index) => {
    if (rows[index].minMarks === "" || rows[index].maxMarks === "") {
      toastr.warning("Please enter Min Marks and Max Marks");
      return;
    } else if (
      marksData[index].minMarks != null &&
      marksData[index].maxMarks != null
    ) {
      dispatch(
        getModeratorCandidateCountByExamIdSubjectId(
          selectedExam,
          selectedSubject,
          marksData[index],
          moderatorCount,
          setModeratorCount,
          index
        )
      );
      setSaveButtonFlag(false);
    }
  };

  const onCalculatePercentage = () => {
    dispatch(
      getModeratorCandidateCountByPercentage(
        selectedExam,
        selectedSubject,
        formPercentageData
      )
    );
  };

  const handleInputChange = (index, fieldName, event) => {
    const newRows = [...rows];
    newRows[index][fieldName] = event.target.value;
    setRows(newRows);
  };

  function downloadCSV(resData) {
    const data = resData.map((item) => ({
      barcodeNo: item.barcodeNo,
      marks: item.marks,
    }));

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [
        ["barcodeNo", "moderatorMarks"],
        ...data.map((item) => [item.barcodeNo, item.marks]),
      ]
        .map((e) => e.join(","))
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "ModeratorBarcodeAndMarks.csv");
    document.body.appendChild(link);
    link.click();
  }

  return (
    <div className="commonContentArea">
      <h5 className="labelMargin">{label.ModeratorCriteria}</h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {headerField &&
            headerField.map((ele, index) => (
              <li className="nav-item" key={ele.id}>
                <a
                  href="#"
                  className={
                    stepName === ele.id
                      ? "nav-link active"
                      : "nav-link bg-profile-tabs"
                  }
                  value="home"
                  id="home-tab"
                  onClick={() => setName(ele.id)}
                  data-toggle="tab"
                  role="tab"
                  aria-controls="home"
                  aria-selected="false"
                >
                  <span>{ele.name}</span>
                </a>
              </li>
            ))}
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "1"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear"
                            value={selectedYear}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo"
                            value={selectedAdvertNo}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam"
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject"
                            value={selectedSubject}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSubjectChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name} ({element.type?.toUpperCase()})
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedSubject.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        {/* <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectSupervisor}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSupervisor"
                            value={supervisor}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onChangeSupervisor(e.target.value);
                            }}

                          >
                            <option>
                              {commonLabels.COMBO_SELECT}
                            </option>

                            {
                              supervisorListById &&
                              supervisorListById.length > 0 &&
                              supervisorListById
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                  // &&
                                  // element.role == "Moderator"
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.role}
                                  </option>
                                ))
                            }
                          </select>
                          {_.get("selectedSupervisor.type", errors) === "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        </div> */}
                      </div>
                      {selectedSubject && selectedSubject > 0 && (
                        <>
                          <div className="row">
                            <div className="form-group col-md-12">
                              <table className="table table-bordered text-center">
                                <thead className="thead-light">
                                  <tr>
                                    <th scope="col">From Marks</th>
                                    <th scope="col">To Till Marks</th>
                                    <th scope="col">Selected Candidates</th>
                                    {/* <th scope="col">Remaining Candidates</th> */}
                                    <th scope="col">Action</th>
                                    {/* <th scope="col">Remove</th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {rows.map((row, index) => (
                                    <tr key={index}>
                                      <td>
                                        <input
                                          type="text"
                                          pattern="^(99|\d{1,2}(?:\.\d{1,2})?)$"
                                          name="minMarks"
                                          className="form-control"
                                          value={row.minMarks || ""}
                                          onChange={(event) =>
                                            handleInputChange(
                                              index,
                                              "minMarks",
                                              event
                                            )
                                          }
                                          onBlur={(event) => {
                                            if (
                                              index !== 0 &&
                                              rows[index - 1].maxMarks >=
                                              event.target.value
                                            ) {
                                              toastr.warning(
                                                "From Marks should be greater than Previous Max Marks"
                                              );
                                              handleInputChange(
                                                index,
                                                "minMarks",
                                                { target: { value: "" } }
                                              );
                                            }
                                            // index !== 0 && (rows[index - 1].minMarks < event.target.value && alert("Min Marks should be less than Max Marks"));
                                            // index !== 0 && (rows[index - 1].minMarks < event.target.value && handleInputChange(index, 'minMarks', { target: { value: "" } })
                                          }}
                                          onKeyPress={(e) => {
                                            const input = e.key.toUpperCase();
                                            const allowedChars = [
                                              "0",
                                              "1",
                                              "2",
                                              "3",
                                              "4",
                                              "5",
                                              "6",
                                              "7",
                                              "8",
                                              "9",
                                            ];

                                            if (
                                              !allowedChars.includes(input) ||
                                              e.target.value.length >= 3
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          min="0"
                                        />
                                        {_.get("minMarks.type", errors) ===
                                          "required" && (
                                            <p className="errorText float-left">
                                              {
                                                commonLabels.MANDATORY_FIELD_MESSAGE
                                              }
                                            </p>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          pattern="^(99|\d{1,2}(?:\.\d{1,2})?)$"
                                          name="maxMarks"
                                          className="form-control"
                                          value={row.maxMarks || ""}
                                          onChange={(event) =>
                                            handleInputChange(
                                              index,
                                              "maxMarks",
                                              event
                                            )
                                          }
                                          onBlur={(event) => {
                                            if (
                                              event.target.value <=
                                              rows[index].minMarks
                                            ) {
                                              toastr.warning(
                                                "Max Marks should be greater than Min Marks"
                                              );
                                              handleInputChange(
                                                index,
                                                "maxMarks",
                                                { target: { value: "" } }
                                              );
                                            }
                                          }}
                                          onKeyPress={(e) => {
                                            const input = e.key.toUpperCase();
                                            const allowedChars = [
                                              "0",
                                              "1",
                                              "2",
                                              "3",
                                              "4",
                                              "5",
                                              "6",
                                              "7",
                                              "8",
                                              "9",
                                            ];

                                            if (
                                              !allowedChars.includes(input) ||
                                              e.target.value.length >= 3
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          min="0"
                                        />
                                        {_.get("maxMarks.type", errors) ===
                                          "required" && (
                                            <p className="errorText float-left">
                                              {
                                                commonLabels.MANDATORY_FIELD_MESSAGE
                                              }
                                            </p>
                                          )}
                                      </td>
                                      <td>
                                        {moderatorCount[index] &&
                                          moderatorCount[index]
                                            .totalSelectedCount}
                                      </td>
                                      {/* <td>
                                        {moderatorCount[index] && moderatorCount[index].remainingCandidateCount}
                                      </td> */}
                                      <td>
                                        <div 
                                        className="d-flex justify-content-center align-items-center gap-5px"                                        >
                                          <button 
                                            type="button"
                                            className="btn btn-outline-primary btn-xs btn-xs-custom"
                                            onClick={() => onCalculate(index)}
                                          >
                                            Apply
                                          </button>
                                          <i
                                            role="button"
                                            data-toggle="tooltip"
                                            title="Delete"
                                            className={
                                              "text-danger fa fa-trash fa-lg"
                                            }
                                            onClick={() => removeRow(index)}
                                          ></i>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                  {/* {moderatorCount.map((moderator, ind) => (
                                    <tr key={ind}>
                                      <td>Total Candidates:<strong>{moderator.totalSelectedCount + moderator.remainingCandidateCount}</strong></td>
                                      <td>Remaining Candidate: <strong>{moderator.remainingCandidateCount}</strong></td>
                                    </tr>
                                  ))} */}
                                </tbody>
                              </table>
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn btn-outline-success btn-xs"
                                  onClick={addRow}
                                >
                                  Add
                                </button>
                                {/* <button
                                  type="button"
                                  className="btn btn-outline-primary btn-xs"
                                  onClick={() => onCalculate()}
                                >
                                  Apply
                                </button> */}
                              </div>
                              <br />
                              {/* {moderatorCount &&
                                <div className="col-md-6">
                                  <table className="table table-bordered text-center">
                                    <tbody>
                                      <tr>
                                        <th scope="col">Total Candidates</th>
                                        <th scope="col">Remaining Candidates</th>
                                      </tr>
                                      <tr>
                                        <td>{moderatorCount.totalSelectedCount}</td>
                                        <td>{moderatorCount.remainingCandidateCount}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              } */}

                              <table className="table table-bordered text-center">
                                <thead className="thead-light">
                                  <tr>
                                    <th scope="col">Percentage</th>
                                    <th scope="col">Selected Candidates</th>
                                    <th scope="col">Remaining Candidates</th>
                                    <th scope="col">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <input
                                        type="text"
                                        pattern="^(0[1-9]|[1-9][0-9]|100)$"
                                        name="percentage"
                                        className="form-control"
                                        value={percentage}
                                        maxLength={5}
                                        onChange={(e) => {
                                          const input = e.target.value;

                                          const firstTwoDigits = input
                                            ? parseFloat(input)
                                            : "";

                                          if (+input === +input) {
                                            if (firstTwoDigits <= 100) {
                                              setPercentage(e.target.value);
                                            }
                                          }
                                        }}
                                      />
                                      {_.get("percentage.type", errors) ===
                                        "required" && (
                                          <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                          </p>
                                        )}
                                    </td>

                                    <td>
                                      {percentageValue.totalSelectedCount}
                                    </td>
                                    <td>
                                      {percentageValue.remainingCandidateCount}
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-xs"
                                        onClick={() => onCalculatePercentage()}
                                      >
                                        Apply
                                      </button>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Total Candidates:</strong>{" "}
                                      {firstTotalCandidateCount}
                                    </td>
                                    <td>
                                      <strong>
                                        Total Remaining Candidate:
                                      </strong>
                                      {percentageValue.remainingCandidateCount ===
                                        undefined
                                        ? remainingCandidateCount
                                        : firstTotalCandidateCount -
                                        (percentageValue.totalSelectedCount +
                                          totalSelectedCandidate)}
                                    </td>
                                    <td>
                                      <strong>Total Selected Candidate:</strong>
                                      {percentageValue.totalSelectedCount ===
                                        undefined
                                        ? totalSelectedCandidate
                                        : percentageValue.totalSelectedCount +
                                        totalSelectedCandidate}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              <strong>Candidates Barcode</strong>
                              <br />
                              <ul
                                className="rollList table-font-12"
                              >
                                {/* {moderatorCount.map(item => item.barcodeNumberList).map((barcodeNo, index) => (
                                  <li key={index}>{barcodeNo}</li>
                                ))}
                                {percentageCount && percentageCount.barcodeNumberList && percentageCount.barcodeNumberList.map((barcodeNo, index) => (
                                  <li key={index}>{barcodeNo}</li>
                                ))} */}
                                {uniqueValues.map((barcodeNo, index) => (
                                  <li key={index}>{barcodeNo}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="row">
                        <div className="form-group col-md-6">
                          <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            onClick={(e) => {
                              onSubmit(e);
                            }}
                            disabled={saveButtonFlag}
                          // onClick={() => onSaveData()}
                          >
                            {moderatorCriteriaStatus
                              ? commonLabels.BUTTON_UPDATE
                              : commonLabels.BUTTON_SAVE}
                          </button>
                          {/* <button
                            type="button"
                            className="btn btn-primary"
                            disabled={saveButtonFlag}
                          // onClick={() => patchData()}
                          >
                            Update
                          </button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "2"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            {moderatorCriteriaApprovalList &&
              moderatorCriteriaApprovalList.entityApprovalDtoList &&
              moderatorCriteriaApprovalList.entityApprovalDtoList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th
                            key={ind}
                            className={`${itm === "No." || itm === "Action"
                              ? "text-center"
                              : ""
                              }`}
                          >
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {moderatorCriteriaApprovalList &&
                      moderatorCriteriaApprovalList.entityApprovalDtoList &&
                      moderatorCriteriaApprovalList.entityApprovalDtoList
                        .length > 0 &&
                      moderatorCriteriaApprovalList.entityApprovalDtoList.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounterMarkCriteria++}
                              </td>
                              <td className="word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className="width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className=" word-break width-10">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>
                              {/* <td className='text-centerw-10 word-break  text-center width-20'>
                                                  {ele.entityApprovalAction.entityApprovalDto.detail && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam.name} <br /> {ele.entityApprovalAction.entityApprovalDto.detail && ele.entityApprovalAction.entityApprovalDto.detail.exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam.name}
                                              </td> */}
                              <td className="w-10 word-break width-20">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam.name}
                                <br />
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam.nameDvng}
                              </td>
                              <td className="w-10 word-break width-15">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject.name}
                                <br />
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.examSubject &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.examSubject.nameDvng}
                              </td>
                              <td>
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>
                              <td>
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className="word-break">
                                {
                                  ele.entityApprovalAction.actionByUser
                                    .firstName
                                }{" "}
                                {ele.entityApprovalAction.actionByUser.lastName}
                              </td>
                              <td className="word-break">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center word-break width-20">
                                {(session.roleName == "superadmin" ||
                                  session.roleName == "desk officer") && (
                                    <button
                                      type="button"
                                      className="mx-auto btn btn-outline-primary btn-sm custom-button"
                                      onClick={() => {
                                        handleMarksCriteriaApproval(ele);
                                      }}
                                    >
                                      {label.REVIEW}
                                    </button>
                                  )}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_moderator_criteria_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListMarkCriteriaCurrentPage}
                  totalCount={moderatorCriteriaApprovalList.totalNoOfRecords}
                />
              </>
            ) : (
              <div className="text-center width-lg-ap">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>
          <div
            className={
              stepName === "3"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear1"
                            value={selectedYear}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear1.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo1"
                            value={selectedAdvertNo}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo1.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam3"
                            // value={selectedExam}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam3.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject3"
                            // value={selectedSubject}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onChangeSubject(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}({element.type?.toUpperCase()})
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedSubject3.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        {/* <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectSupervisor}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSupervisor3"
                            value={supervisor}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onChangeSupervisorId(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {
                              supervisorListById &&
                              supervisorListById.length > 0 &&
                              supervisorListById
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true &&
                                    element.role == "Moderator"
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.role}
                                  </option>
                                ))
                            }
                          </select>
                          {_.get("selectedSupervisor3.type", errors) === "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        </div> */}
                      </div>
                      <div className="row">
                        <div className="form-group col-md-6">
                          <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "4"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear4"
                            value={selectedYear}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo4"
                            value={selectedAdvertNo}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam4"
                            // value={selectedExam}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject4"
                            // value={selectedSubject}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onChangeSub(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}({element.type?.toUpperCase()})
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedSubject4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-6">
                          <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>

                          {(session.roleName == "superadmin" ||
                            session.roleName == "secretary") && (
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={saveButtonFlag || !getModerationData.moderationNotDoneReportDtos}
                                onClick={() => {
                                  genPdf();
                                }}
                              >
                                {commonLabels.BUTTON_PRINT}
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {selectedSubject &&
              getModerationData &&
              getModerationData.moderationNotDoneReportDtos &&
              getModerationData.moderationNotDoneReportDtos.length > 0 && (
                <div ref={pdfRef}>
                  <table className="table text-center">
                    <thead>
                      <tr className="text-center">
                        <th
                          colspan="5"
                          className="customTableStyle"
                        >
                          <span>Examiner Marks</span>
                          <br />
                          <span>Moderator Marks</span>
                        </th>
                        <th
                          colspan="5"
                          className="customTableStyle"
                        >
                          <span>Examiner Marks</span>
                          <br />
                          <span>Moderator Marks</span>
                        </th>
                      </tr>
                      <tr>
                        <th
                          className="customTableStyle"
                        >
                          <span>Sr. No.</span>
                          <br />
                          <span>CODE</span>
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q1
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q2
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q3
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Total
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          <span>Sr. No.</span>
                          <br />
                          <span>CODE</span>
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q1
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q2
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q3
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {getModerationData.moderationNotDoneReportDtos.map(
                        (item, index) => (
                          <React.Fragment key={index}>
                            <tr>
                              <td>
                                <span>{index + 1}</span>
                                <br />
                                <span>
                                  <strong>{item.code}</strong>
                                </span>
                              </td>
                              <td>
                                <span>{item.examinerMarks}</span><br />
                                <span>{item.moderatorMarks}</span>
                              </td>
                              <td>-</td>
                              <td>-</td>
                              {/* <td>{item.moderatorMarks || "-"}</td> */}
                              {/* <td>{item.chiefModeratorMarks || "-"}</td> */}
                              <td>{item.total}</td>
                            </tr>
                          </React.Fragment>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            <br />
            <br />
          </div>
          {moderatorCriteriaApprovalEntityModal && (
            <ApprovalModeratorCriteriaEntity
              showModal={moderatorCriteriaApprovalEntityModal}
              setShowModal={setModeratorCriteriaApprovalEntityModal}
              setSelectedApprovalEntity={
                selectedModeratorCriteriaApprovalEntity
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ModeratorCriteria;
